<template>
    <card shadow>
      <a :href="photoURL" target="_blank">
        <img
          :src="photoURL"
          class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
          style="width: 140px;"
        />
      </a>
      <div class="pt-4 text-center">
        <h5 class="h3 title">
          <span class="d-block mb-1">{{displayName}}</span>
          <small class="h4 font-weight-light text-muted">{{userTitle}}</small>
        </h5>
        <div class="mt-3">
          <router-link :to="{ name: 'profile' }" class="btn btn-primary text-white">
            My Profile and Organization
          </router-link>
        </div>
      </div>
    </card>
</template>

<script>
export default {
  name: "usercard",
  props: {
    photoURL: String,
    displayName: String,
    userTitle: String,
  }
};
</script>

<style scoped>
</style>
